
import enUs from './en-us'
import zhCn from './zh-cn'
 
//导出所有翻译内容
export default {
    'zh-cn': zhCn,
    'en-us': enUs
}